export default "__VITE_ASSET__DPDFBh1K__"